window.onload = function() {
      $(".contact-form [name=commit]").click(function(e) {
        	console.log("test")
          e.preventDefault();        
          var contact_email = $('.contact-form [type=email]').val();
          var settings = {
              "async": true,
              "crossDomain": true,
              "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
              "method": "POST",
              "headers": {
                  "content-type": "application/x-www-form-urlencoded",
                  "cache-control": "no-cache"
              },
              "data": {
                  "g": "TZU7Jp",
                  "email": contact_email
              }
          };

          if (validateSubscribeEmail(contact_email)) {
              $.ajax(settings).done(function(response) {
                  if (response.success) {
                      $('.contact-form [type=email]').val("")
                      $(".contact-form .contact-wrapper").html(`<div class="note-success-wrapper">
                      <div class="note note--success">You're in! Please be on the lookout for updates & new releases.</div>
                      </div>`);
                  } else {
                      $(".contact-form .contact-wrapper").html(`<div class="note-success-wrapper">
                      <div class="note note--success form-error">An error occurred, please try again.</div>
                      </div>`);
                  }

              });
          } else {
              $(".contact-form .contact-wrapper").html(`<div class="note-success-wrapper">
                      <div class="note form-error">Invalid email address. Please enter again.</div>
                      </div>`);
          }
      });

      function validateSubscribeEmail($email) {
          var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return emailReg.test($email);
      }
}